import React from 'react';
import GreetlyVouchers from './GreetlyVouchers';

const BaristaGreetlyVouchers = () => (
    <GreetlyVouchers
        pageTitle='Barista Greetly Vouchers'
        storeFilter='Barista'
        tableVariant='barista'
    />
);

export default BaristaGreetlyVouchers;